import { APP_CONFIG } from 'src/app/helper/Appcode/app-config.service';
import { DocumentService } from './helper/Services/document.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
import config from 'devextreme/core/config';
import { Title } from '@angular/platform-browser';
import { NgxPermissionsService } from 'ngx-permissions';
import { locale } from 'devextreme/localization';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = '';
  rtlEnabled = false;
  constructor(private translate: TranslateService,
              private documentService: DocumentService,
              private titleService: Title
    ) {
  }
  ngOnInit(): void {
    this.initTranslate();

    // const perm = ["SYSowner", "SYSadmin","opertor","superemployee","employee","auditor",
    // "ExecuseType","VacationType","WorkOutType","shifts","attendancesetting","empinfo","calender","vcredit","agenda",
    // "checkopreration","execopreration","vacopreration","woutopreration","appsettings","Vactions","Execuses","Workout","TimeAssgining"];

  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.addLangs(['en','ar']);
    this.translate.setDefaultLang('ar');
   // this.translate.use(this.translate.getBrowserLang() || 'en');
    if (this.translate.getDefaultLang() === 'ar' ) {
      this.title =  APP_CONFIG.ArClientName + " " + APP_CONFIG.ArProductName;
      this.documentService.setReadingDirection('rtl');
      this.rtlEnabled = true;
      config({
        rtlEnabled: true
      });
    locale("ar-EG")

    }
    else{
      this.title =  APP_CONFIG.EnClientName + " " + APP_CONFIG.EnProductName;
    }


    this.titleService.setTitle(this.title);

  }
}
